import quoteFlowHeroWidget from './quote-flow-hero-widget';
let xhr;
if(window.validationMessages != undefined){
  $.validator.addMethod('postalCode', function (value) {
    return ValidateZip(value);
  }, validationMessages.messages["Postal Code Matches Pattern"]);

  function ValidateZip(val) {
    if (new RegExp(postalCodeRegex).test(val)) {
      return true;
    }
    else {
      console.log("validation of " + val + " failed against '" + postalCodeRegex + "'")
      return false;
    }
  }
  $.validator.addMethod('emailValidation', function (value) {
    let emailValidationType = $('input[name="emailAddress').hasClass('emailValidation') ? 'emailValidation' : '';
    return ValidateEmail(value, emailValidationType);
  }, validationMessages.messages["Email Matches Pattern"]);

  function ValidateEmail(value, emailValidationType) {
    var emailValid = false;
    if (emailValidationType == "emailValidation" && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value))
    {
      emailValid = true;
    }
    //original validation regex
    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
    {
      emailValid = true;
    }
    if (emailValid){
      return(true)
    }
    else{
      console.log("validation of " + value + " failed'")
      return (false)
    }
  }
}

if(document.quoteFlowWidgetForm){
  jQuery.extend(jQuery.validator.messages, {
    email: window.validationMessages.messages["Email Matches Pattern"],
    emailValidation: window.validationMessages.messages["Email Matches Pattern"],
    //RS: 04-11-2022 - ADO: 6451 - Add Date selected validation
    selectedDate: window.validationMessages.messages["Date Selected"],
    postalCode: window.validationMessages.messages["Postal Code Matches Pattern"],
    maxlength: window.validationMessages.messages["Email Matches Pattern"]
  });
  setTimeout(function(){
    document.quoteFlowWidgetForm.reset();
  }, 1000);
  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  function ValidateZip(val) {
    if (!val) { return false; }
    if (new RegExp(postalCodeRegex).test(val)) {
      console.debug(`[ValidateZip] Validation of ${val} succeeded`);
      return true;
    }
    else {
      console.debug(`[ValidateZip] Validation of ${val} failed against '${postalCodeRegex}'`)
      return false;
    }
  }
  function UpdateFRCalendarDates(dateArray) {
    allDisabledDates = dateArray;
    //allDisabledDates = allDisabledDates.concat(dateArray);

    $('.selected-date-picker').datepicker('setDatesDisabled', allDisabledDates);

    //If they've somehow selected an unavailable date, clear it
    if (allDisabledDates.includes($('.selected-date-picker').data('datepicker').getFormattedDate('d/m/yyyy'))) {
      $('.selected-date-picker').data("datepicker").clearDates()
    }

    //$('.selected-date-picker').data("datepicker").date(null);
    $('.selected-date-picker').data("datepicker").o.defaultViewDate = datePickerReferenceDate;
    $('.selected-date-picker').data("datepicker").update()
    $('.selected-date-picker').prop('disabled', false);
  };
  function UpdateCalendarDates(dateArray) {
    allDisabledDates = dateArray;
    //allDisabledDates = allDisabledDates.concat(dateArray);
    //RS 10-04-2022 - Disable all dates 1 year from now
    var oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    $('.selected-date-picker').datepicker('setDatesDisabled', allDisabledDates).datepicker('setEndDate', oneYearFromNow);

    //If they've somehow selected an unavailable date, clear it
    if (allDisabledDates.includes($('.selected-date-picker').data('datepicker').getFormattedDate('m/d/yyyy'))) {
      $('.selected-date-picker').data("datepicker").clearDates()
    }

    //$('.selected-date-picker').data("datepicker").date(null);
    $('.selected-date-picker').data("datepicker").o.defaultViewDate = datePickerReferenceDate;
    $('.selected-date-picker').data("datepicker").update()

    $('.selected-date-picker').prop('disabled', false);
  };

  function showModal(modalContent) {
    console.debug("Attempting to show modal");
    var modalHolder = document.getElementById("pods-modal__holder");
    modalHolder.classList.remove("modal__youtube_holder");
    modalHolder.querySelector('.modal__content-holder').innerHTML = modalContent;
    document.body.classList.add('modal__open');
  };

  /////////////////////////////////////////////////////////
  // Serviceability
  /////////////////////////////////////////////////////////

  function SendServiceabilityRequest(serviceabilityData, zip, source) {
    console.debug(`[SendServiceabilityRequest] Getting Calendar Data (referenceDate: ${serviceabilityData.referenceDate}, referenceMonth: ${serviceabilityData.referenceMonth})`);

    referencedMonths.push(serviceabilityData.referenceMonth);

    var sendstr = JSON.stringify(serviceabilityData);
    // Check move type before send
    if(serviceabilityData.serviceType == "2" || ((serviceabilityData.serviceType == "1" || serviceabilityData.serviceType == "3") && serviceabilityData.originZipCode != '' && ValidateZip(serviceabilityData.originZipCode)  && serviceabilityData.destinationZipCode != '' && ValidateZip(serviceabilityData.destinationZipCode)))
    {
      console.debug("[SendServiceabilityRequest] Request Send -- ", serviceabilityData);
      if (xhr) {
        xhr.abort();
        }
        xhr = $.ajax({
        type: 'POST',
        url: '/api/PODS/ServiceabiltyCheck',
        contentType: 'application/json',
        dataType: 'json',
        cache: false,
        data: sendstr,
        success: function (servicabilityResponse) {
          console.debug("[SendServiceabilityRequest.success] servicabilityResponse -- ", servicabilityResponse);
          handleServicabilityResponse(servicabilityResponse, zip, source);
          try {
            var disabledDates = servicabilityResponse.GeneralAvailabilityDates.filter(item => !item.IsAvailable);

            //TODO: FRENCH
            disabledDates = disabledDates.map(a => a.Date);

            var frenchDates = disabledDates.map(function(x){
              var dateAr  = x.split("/");
              return x.replace(x, dateAr[1] + '/' + dateAr[0] + '/' + dateAr[2]);
            });
            if (window.location.href.indexOf("ca/fr") > -1) {
              //UpdateFRCalendarDates(disabledDates);
              // for Raj - comment the line above, uncomment the line below
              UpdateFRCalendarDates(frenchDates);
            }
            else {
              UpdateCalendarDates(disabledDates);
            }

            generalDates = servicabilityResponse.GeneralAvailabilityDates;
            sevenFootDates = servicabilityResponse.SevenFootContainerAvailabilityDates;
            sixteenFootDates = servicabilityResponse.SixteenFootContainerAvailabilityDates;
            twelveFootDates = servicabilityResponse.TwelveFootContainerAvailabilityDates;
          } catch (e) {

          }
          $("#loadingTBody").remove();
          $(".datepicker-days tbody").show();
        },
        error(servicabilityResponse, textStatus, errorThrown) {
          if (xhr.abort())
            $("#loadingTBody").remove();
            return;

            handleServicabilityResponse(servicabilityResponse, zip, source);
        }
      });
    }
    else {
      document.getElementById('QuoteFlowWidget').classList.remove('loading-widget');
    }
  }

  function GetServiceabilityParameters() {
    var serviceTypeElement = document.querySelector('input[name=serviceType]:checked');
    var serviceType = "";
    if (serviceTypeElement) {
      serviceType = serviceTypeElement.value;
    }
    var originZip = document.querySelector('.originZipCode-Input').value;
    var destinationZip = document.querySelector('.destinationZipCode-Input').value;
    var customerType = $("input[name='businessType']:checked").val();
    var cloudAPI = $("input[name='useCloudAPI']").val();
    //if (!destinationZip || destinationZip == "") {
    //  document.querySelector('.destinationZipCode-Input').value = originZip;
    //}

    var referenceMonth = datePickerReferenceDate.getMonth();
    var data =
    {
      "serviceType": serviceType,
      "quoteFlowDatasourceId": quoteFlowDatasourceId,
      "originZipCode": originZip,
      "destinationZipCode": destinationZip,
      "referenceDate": formatDate(datePickerReferenceDate),
      "referenceMonth": referenceMonth,
      "CustomerType": customerType,
      "UseCloudAPI" : cloudAPI,
    }

    return data;
  }

  /////////////////////////////////////////////////////////
  // Get Price
  /////////////////////////////////////////////////////////

  function AlignZipCodes() {
    // copy origin zipcode to destination if there wasn't any value
    if (document.quoteFlowWidgetForm.destinationZipCode.value == "") {
      document.quoteFlowWidgetForm.destinationZipCode.value = document.quoteFlowWidgetForm.originZipCode.value
    }
  }

  function GetSalesforceQuoteFlowParameters() {
    var businessType = document.querySelector('input[name=businessType]:checked').value;
    var serviceTypeElement = document.querySelector('input[name=serviceType]:checked');
    var serviceType = "";
    if (serviceTypeElement) {
      serviceType = serviceTypeElement.value;
    }

    var originZip = document.querySelector('.originZipCode-Input').value;
    var originCity = document.querySelector('.originCity-Input').value;
    var destinationZip = document.querySelector('.destinationZipCode-Input').value;
    var destinationCity = document.querySelector('.destinationCity-Input').value;
    var durationElement = document.querySelector('.duration-Input');
    var duration = "";
    if (durationElement) {
      duration = document.querySelector('select[name=duration]').value;
    }
    //RS: 04-11-2022 - ADO: 6451 - Add quote flow parameters

    //RS: 2023-04-05 - Restoring original checks
    var selectedDate = document.querySelector('.selectedDate-Input').value;
    var selectedDate_display =  document.querySelector('.selectedDate-Input').value;
    //RS: 2023-05-30 - fix french selected dates until we can refactor
    var selectedDate_displayFR =  document.querySelector('input[name=selectedDate_display]').value;
    var dateParts = selectedDate_displayFR.split('/');
    if (window.location.href.indexOf("/fr") > -1) {
      document.querySelector('input[name=selectedDate_display]').value = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
    }
    var storingLocationElement = document.querySelector('input[name=storingLocation]:checked');
    var storingLocation = "";
    if (storingLocationElement) {
      storingLocation = storingLocationElement.value;
    }
    var email = document.querySelector('.email-Input').value;
    var promotionCode = document.querySelector('.promotionCode-Input').value;

    var selectedDateUTCTimestamp = new Date(Date.UTC(new Date(parseInt(selectedDate)).getUTCFullYear(), new Date(parseInt(selectedDate)).getUTCMonth(), new Date(parseInt(selectedDate)).getUTCDate())).getTime();

    for (var i in sevenFootDates) {
      var checkedDateUTCValue = new Date(Date.UTC(new Date(sevenFootDates[i].Date).getUTCFullYear(), new Date(sevenFootDates[i].Date).getUTCMonth(), new Date(sevenFootDates[i].Date).getUTCDate()));
      if (checkedDateUTCValue.getTime() == selectedDateUTCTimestamp) {
        document.getElementById('hdnSevenFootIsAvailable').value = sevenFootDates[i].IsAvailable;
        break; //Exit the loop, we're done.
      }
    };
    for (var i in twelveFootDates) {
      var checkedDateUTCValue = new Date(Date.UTC(new Date(twelveFootDates[i].Date).getUTCFullYear(), new Date(twelveFootDates[i].Date).getUTCMonth(), new Date(twelveFootDates[i].Date).getUTCDate()));
      if (checkedDateUTCValue.getTime() == selectedDateUTCTimestamp) {
        document.getElementById('hdnTwelveFootIsAvailable').value = twelveFootDates[i].IsAvailable;
        break; //Exit the loop, we're done.
      }
    };
    for (var i in sixteenFootDates) {
      var checkedDateUTCValue = new Date(Date.UTC(new Date(sixteenFootDates[i].Date).getUTCFullYear(), new Date(sixteenFootDates[i].Date).getUTCMonth(), new Date(sixteenFootDates[i].Date).getUTCDate()));
      if (checkedDateUTCValue.getTime() == selectedDateUTCTimestamp) {
        document.getElementById('hdnSixteenFootIsAvailable').value = sixteenFootDates[i].IsAvailable;
        break; //Exit the loop, we're done.
      }
    };

    var data =
    {
      "businessType": businessType,
      "serviceType": serviceType,
      //switched this to a date display to be converted later
      "selectedDate": new Date(selectedDate),
      "selectedDate_display": selectedDate_display,
      "originZipCode": originZip,
      "originCity": JSON.parse(originCity),
      "destinationZipCode": destinationZip,
      "destinationCity": JSON.parse(destinationCity),
      "duration": duration,
      "emailAddress": email,
      "promotionCode": promotionCode,
      "contactId": contactId,
      "contactIp": contactIP,
      "quoteType": quoteType,
      "moveType": moveType,
      "quoteFlowDatasourceId": quoteFlowDatasourceId,
      "erpService": erpService,
      "GoalId": goalId,
      "PodsPhone": podsPhone,
      "hdnSevenFootIsAvailable": document.getElementById('hdnSevenFootIsAvailable').value,
      "hdnTwelveFootIsAvailable": document.getElementById('hdnTwelveFootIsAvailable').value,
      "hdnSixteenFootIsAvailable": document.getElementById('hdnSixteenFootIsAvailable').value,
      "storingLocation": storingLocation,
      "queryStringValues": []
    }
    console.debug("[GetSalesforceQuoteFlowParameters]", data);
    return data;
  }

  /////////////////////////////////////////////////////////
  // Add Validation to form
  /////////////////////////////////////////////////////////
  jQuery.validator.setDefaults({
    //debug: true,
    success: "valid"
  });

  $(document.quoteFlowWidgetForm).validate({
    onclick: false,
    onfocusout: false,
    focusInvalid: false,
    focusCleanup: true,
    highlight: function (element) {
      $(element).addClass("is-invalid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid");
    },
    rules: {
      businessType: { required: true },
      serviceType: { required: true },
      originZipCode: { required: true, postalCode: true },
      destinationZipCode: { required: true },
      selectedDate: { required: true },
      selectedDate_display: { required: true },
      duration: { required: true },
      storingLocation: { required: true },
      emailAddress: { required: true, maxlength: 80, emailValidation: true},
      format: { required: true }
    },
    errorPlacement: function (error, element) {
      return true;
    },
    showErrors: function (errorMap, errorList) {
      const summary = $("#summary");

      if (this.numberOfInvalids() != 0) {
        summary.show();
        summary.addClass('pb-2');

        if (errorMap.originZipCode || errorMap.destinationZipCode) {
          summary.addClass('small');
          summary.html(`${validationMessages.messages["Postal Code Matches Pattern"]} <br> ${validationMessages.messages["All Required Fields"]}`);
        } else if (errorMap.emailAddress) {
          summary.addClass('small');
          let errorMessages = validationMessages.messages["All Required Fields"];
          if (validationMessages.messages["Email Max Length"]) {
            errorMessages = `${validationMessages.messages["Email Max Length"]} <br> ${errorMessages}`;
          }
          summary.html(errorMessages);
        } else {
          summary.removeClass('small');
          summary.html(`${validationMessages.messages["All Required Fields"]} (${this.numberOfInvalids()})`);
        }

        this.defaultShowErrors();
      } else {
        summary.hide();
        summary.removeClass('pb-2');
        summary.removeClass('small');
      }
    }
  });

  function validateZipCodeFields() {
    var selectedServiceType = document.querySelector('input[name=serviceType]:checked').value;
    var originZipValue = document.querySelector('.originZipCode-Input').value;
    var destinationZipValue = document.querySelector('.destinationZipCode-Input').value;

    if (originZipValue == null || originZipValue == "") {
      $('#originZipCode').addClass('is-invalid');
    }

    if (selectedServiceType == 1 || selectedServiceType == 3) { // Moving or Moving & Storage
      if (destinationZipValue == null || destinationZipValue == "") {
        $('#destinationZipCode').addClass('is-invalid');
      }
    }
  }
  //RS 2022-12-7 - City Service redirect in case they choose YES
  function setCityServiceRedirect() {
    var selectedValue = $('#pavedDriveway input').is(":checked") ? document.querySelector('#pavedDriveway input:checked').value : "no";
    var submitButton = $('#quoteFlowWidgetForm input[type=submit]');
    var landingPageURLHiddenField = document.getElementById('hdnLandingPageUrl');
    var serviceType = sessionStorage.getItem('StatusType');
    landingPageURLHiddenField.value = "";
    if (selectedValue.toUpperCase() == "YES"){
      if (serviceType == "IFCityServiceQualifier"){
          document.forms.quoteFlowWidgetForm.action = sessionStorage.getItem('IF_FallbackURL');
          landingPageURLHiddenField.value = "";
          document.querySelector('.moveType-Input').value = "IF";
      }
      else
      {
        document.forms.quoteFlowWidgetForm.action = "/booking";
        document.querySelector('.moveType-Input').value = "basic";
      }
    }
    else {
      landingPageURLHiddenField.value = "/city-service-moves";
      document.forms.quoteFlowWidgetForm.action = "/city-service-moves";
    }
  }

  function SetMovingValidation() {
    $(".Moving-Visable").rules("add", { required: true });
    $(".destinationZipCode-Input").rules("add", { required: true, postalCode: true });
    //RS: 04-11-2022 - ADO: 6451 - Add Valitidation rule
    $(".selectedDate-Input").rules("add", { required: true });
    $(".Storage-Visable").rules("remove");
  }

  function SetStorageValidation() {
    $(".destinationZipCode-Input").rules("remove");
    $(".Storage-Visable").rules("add", { required: true });
    $(".Moving-Visable").rules("remove");
  }

  function SetMovingAndStorageValidation() {

    $(".Storage-Visable").rules("add", { required: true });
    $(".Moving-Visable").rules("add", { required: true });
    $(".destinationZipCode-Input").rules("add", { required: true, postalCode: true });
  }

  function SetServiceTypePanel(radioButton) {
    if (!radioButton) {
      radioButton = document.querySelector('.serviceType-radio:checked');
    }

    if (radioButton && radioButton.checked) {
      if (radioButton.value == 1) {
        SetMovingValidation();
        SetMovingFields();
        SetStorageLocationStatus();
      }
      else if (radioButton.value == 2) {
        SetStorageValidation();
        SetStorageFields();
        SetStorageLocationStatus();
      }
      else if (radioButton.value == 3) {
        SetMovingAndStorageValidation();
        SetMovingAndStorageFields();
        SetStorageLocationStatus();
      }
    }
  }

  /////////////////////////////////////////////////////////
  // Toggle form fields
  /////////////////////////////////////////////////////////

  function SetMovingFields() {
    $(".Moving-Visable").removeClass('d-none');
    $(".Storage-Visable").addClass('d-none');
    $(".Storage-Duration").removeClass('col-6').removeClass('col-12');
    $('#divZipCode').removeClass('col-12').addClass("col-6");
    $('#divQuoteCalender').removeClass('col-12').addClass("col-6");
  }

  function SetStorageFields() {
    $(".Moving-Visable").addClass('d-none');
    $(".Storage-Visable").removeClass('d-none');
    var driveway = document.getElementById("pavedDriveway");

    if (driveway.classList.contains('d-none')){
    $(".Storage-Duration").removeClass('col-6').addClass('col-12');
      $('#divQuoteCalender').addClass('col-6').removeClass('col-12');
    }
    else {
      $(".Storage-Duration").removeClass('col-12').addClass('col-6');
      $('#divZipCode').addClass('col-12');
    }
  }

  function SetMovingAndStorageFields() {
    $(".Moving-Visable").removeClass('d-none');
    $(".Storage-Visable").removeClass('d-none');
    $(".Storage-Duration").removeClass('col-12').addClass('col-6');
    $('#divZipCode').removeClass('col-12').addClass('col-6');
    $('#divQuoteCalender').removeClass('col-12').addClass('col-6');  ;
  }

  /////////////////////////////////////////////////////////
  // Add Events To Form
  /////////////////////////////////////////////////////////
  $('#selected-date-picker').on('click', validateZipCodeFields);

  $('#pavedDriveway input').on('click', setCityServiceRedirect);
  $('#promoCodeToggle').on('click', function () {
    $('.promotionCode-Input').toggle();
    $(this).toggleClass('collapsed');
  });

  document.addEventListener('DOMContentLoaded', function () {

    window.onpageshow = function(e) {
      SetServiceTypePanel();
    };

    if ($('.promotionCode-Input').val() != "")
      $('.promotionCode-Input').show();

    $('.selected-date-picker').prop('disabled', true);

    var submitButton = document.querySelector('#quoteFlowWidgetForm input[type="button"]');
    submitButton.addEventListener('click', (e) => {
      try {
        if ($("[name=quoteFlowWidgetForm]").valid() && $('#selected-date-picker').is(':disabled')) {
          e.preventDefault();
          // They probably got back to this page using browser history, which filled in the zip code but didn't perform the serviceability check.
          // Do that now.
          document.getElementById('QuoteFlowWidget').classList.add('loading-widget');
          let params = GetServiceabilityParameters();
          let zip = params.originZipCode, source = 'origin';
          if ($('.destinationZipCode-Input').is(':visible')) {
            zip = params.destinationZipCode;
            source = 'destination';
          }
          SendServiceabilityRequest(params, zip, source);
        } else if ($("[name=quoteFlowWidgetForm]").valid()) {
          $('#LoadingScreen').css("display", "block");
          $('body').css("overflow-y", "hidden");
          window.setTimeout(() => {
          AlignZipCodes();

          var quoteInfo = GetSalesforceQuoteFlowParameters();
          SendQuoteToSalesforce(quoteInfo);

          /* TODO REFACTOR: This logic needs to be changed so that we're doing real Form POSTs to the target page rather than just shoving things into the session and redirecting.*/

          /* AV:2021-03-25 - ADO:4028/4261 - IFPD logic only applies to quotes that are for 1 or 2 months. Discounts kick in at 3 months, so for now we're not including them in the test. */
          /* AV:2021-03-26 - ADO:4028/4263 - IFPD logic only applies to quotes without promotions. */

          var storageDuration = parseInt(document.querySelector('select[name=duration]').value);
          var promotionCode = document.querySelector('.promotionCode-Input').value;

          if ((document.querySelector('.moveType-Input').value == "IFNP" || document.querySelector('.moveType-Input').value == "IFPD") &&
            ((storageDuration >= 3) || (promotionCode.length > 0))) {
            document.querySelector('.moveType-Input').value = "IF";
          }
          //RB:2021-05-12 - ADO:4214 - datalayer-Step1-Quote
          var subCategory = 'Moving';
          if ($("input[name='serviceType']:checked").val() == '2') {
            subCategory = "Storage";
          }
          else if ($("input[name='serviceType']:checked").val() == '3') {
            subCategory = "Moving and Storage";
          }
          var storageLocation = "PODS Facility";
          if(document.getElementById("onsite").checked){
            storageLocation = "My Location";
          }

          var originCity = document.querySelector('.originCity-Input').value;
          var origionObj = JSON.parse(originCity);

          var moveType = document.querySelector('.moveType-Input').value;
          if(moveType.toUpperCase().indexOf('BASIC')  != -1){
            moveType = 'Local';
          }

          var dataLayerObj = {
            'event': 'checkout',
            'ecommerce': {
              'checkout': {
                'actionField': {
                  'option': 'Quote',
                  'step': '1'
                },
                'products': [{
                  'category': $("input[name='businessType']:checked").val(),
                  'subcategory': subCategory,
                  'currency': 'USD',
                  'dimension9': origionObj.FranchiseeId,
                  'dimension10': $("#storage-duration").val(),
                  'id': 'placeholder', //required value
                  'name': 'placeholder', //required value
                  'promoCodeEntered': promotionCode,
                  'promoCodeApplied': promotionCode,
                  'storingLocation': storageLocation,
                  'originZip': $("#originZipCode").val(),
                  'destinationZip': $("#destinationZipCode").val(),
                  'url': window.location.href.split('?')[0],
                  'variant': moveType
                }]
              }
            }
          };
          dataLayer.push(dataLayerObj);
          localStorage.setItem("dataLayer", JSON.stringify(dataLayerObj));

          var landingPageURLHiddenField = document.getElementById('hdnLandingPageUrl');
          if (landingPageURLHiddenField.value) {
            e.preventDefault();
            sessionStorage.setItem('quoteInfo', JSON.stringify(quoteInfo));

            window.location.href = landingPageURLHiddenField.value;
            return false;
          }

          $("[name=quoteFlowWidgetForm]").submit();
        }, 1000);
        }
      } catch (e) {
        console.error(e);
        $('body').css("overflow-y", "scroll");
        $('#LoadingScreen').css("display", "none");
      }

    });

    var serviceTypes = document.querySelectorAll('.serviceType-radio');
    for (var i = 0; i < serviceTypes.length; i++) {
      serviceTypes[i].addEventListener('change', (e) => {
        $('#selected-date-picker').prop("disabled", true);
        $('#originZipCode').removeClass("is-invalid");
        $('#destinationZipCode').removeClass("is-invalid");

        if (e.target.checked) {
          SetServiceTypePanel(e.target);
          ClearZipCodes();
        }
      });
    }

    var durationElement = document.getElementById('storage-duration');
    durationElement.addEventListener('change', () => {
      $('#storage-duration').removeClass("is-invalid");
    });

    var destinationZipElement = document.querySelector('.destinationZipCode-Input');
    var originZipElement = document.querySelector('.originZipCode-Input');
    originZipElement.addEventListener('keyup', (e) => {
      originZip = e.target.value;
      let destinationZip = destinationZipElement ? destinationZipElement.value : '';
      HandleZipCodeKeyUp(originZip, destinationZip, e.target, 'origin');
    });

    destinationZipElement.addEventListener('keyup', (e) => {
      let originZip = originZipElement ? originZipElement.value : '';
      destinationZip = e.target.value;
      HandleZipCodeKeyUp(originZip, destinationZip, e.target, 'destination');
    });

    var emailInput = document.querySelector('.email-Input');
    emailInput.addEventListener('change', (e) => {
      document.getElementsByClassName('email-Input')[0].classList.remove('is-invalid');
      $("#summary").hide();
    });

    const calendarObserver = new MutationObserver(function() {

      // JW:2021-07-02 - ADO:5014
      // Do not remove the disconnect() unless you remove the MutationObserver fix completely!
      calendarObserver.disconnect();
      // Do not remove the disconnect() unless you remove the MutationObserver fix completely!

      // JW:2021-07-02 - ADO:5014 - the rest of this is ported from the datepicker changeMonth event handler below
      // Serviceability returns checks for -7 days and +35 days for the date that you give it
      // So this offset gets serviceability for all days displayed in the calendar
      datePickerReferenceDate = new Date($('.day:first').data('date'));
      //console.log(`first callback: ${datePickerReferenceDate.toUTCString()}`);
      //RS - check if legacy, add 7 days to cover long months - adjusted to exclude French so the full month gets returned
      if (($("input[name='useCloudAPI']").val() !== true) && (document.location.href.indexOf('/fr') === -1)){
        datePickerReferenceDate.setDate(datePickerReferenceDate.getDate() + 7);
      }
      else if (document.location.href.indexOf('/fr') > -1) {
        datePickerReferenceDate.setDate(datePickerReferenceDate.getDate() + 1);
      }
      console.debug(`calendarObserver callback datePickerReferenceDate: ${datePickerReferenceDate.toUTCString()}`);

      SendServiceabilityRequest(GetServiceabilityParameters());
    });

    //RS: 2022-05-27 - ADO: 6865 - Change Calendar to French if URL is different
    if (window.location.href.indexOf("/fr") > -1) {
      $('#selected-date-picker').datepicker({
        language: "fr",
        // for Raj - switch to fr
        startDate: datePickerReferenceDate,
        minDate: 0,
        autoclose: true,
        maxViewMode: 1,
        disableEntry: true,
        updateViewDate: false,
        orientation: 'bottom',
        //rs - disabling this until we can figure out how to handle really long months w/ more than 42 days
        daysOfWeekDisabled: [0],
      }).on('show', function (e) {
        //RS: adding the class for the cloud api if true
        if($('input[name="useCloudAPI"]').val() == "true"){
          $('.datepicker-dropdown').addClass("cloudAPI");
        }
      }).on('changeDate', function (datepicker) {
        document.querySelector('.selectedDate-Input').value = datepicker.date.getTime();

        var dateAr  = $(this).val().split("/");
        var acceptedDate =  dateAr[1] + '/' + dateAr[0] + '/' + dateAr[2];
        //RS 2023-03-31: correcting comment
        document.querySelector('.selectedDate-Input').setAttribute('data-date', acceptedDate);

        document.getElementById('selected-date-picker').classList.remove('is-invalid');
        const storageLocation = document.querySelector('.storage-location');
        var selectedDateUTCTimestamp = new Date(Date.UTC(new Date(selectedDate).getUTCFullYear(), new Date(selectedDate).getUTCMonth(), new Date(selectedDate).getUTCDate())).getTime();
        //rs - 2023-04-03 - Setting up postal code statuses
        var currentWarehouseStatus = sessionStorage.getItem('PostalCodeExceptionNSO');
        var selectedDateUTCTimestamp = new Date(Date.UTC(new Date(datepicker.date).getUTCFullYear(), new Date(datepicker.date).getUTCMonth(), new Date(datepicker.date).getUTCDate())).getTime();
        for (var i in generalDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(generalDates[i].Date).getUTCFullYear(), new Date(generalDates[i].Date).getUTCMonth(), new Date(generalDates[i].Date).getUTCDate()));
          if (checkedDateUTCValue.getTime() == selectedDateUTCTimestamp) {
            //rs 2023-03-10 - Check the postal code exception, still respecting that if the sales are blocked in the module, it will always be false
            if(generalDates[i].LocalSalesBlocked || currentWarehouseStatus == 1) {
              storageLocation.setAttribute('data-warehouse-storage-status', 1);
            }
            else if(currentWarehouseStatus == 2 ) {
              storageLocation.setAttribute('data-warehouse-storage-status', 2);
            }
            else if(currentWarehouseStatus == 3 ) {
              storageLocation.setAttribute('data-warehouse-storage-status', 3);
            }
            else {
              storageLocation.setAttribute('data-warehouse-storage-status', 0);
            }
          }
        }
        SetStorageLocationStatus();

        $("#summary").hide();
      }).on('changeMonth', function () {
        if (originZip == null || originZip == "")
          return;

        $(".datepicker-days tbody").hide();
        $("div.datepicker-days table").after("<div id='loadingTBody' style='width: 284px; border: 2px solid #c6cdd4; font-weight: bold; text-align: center; padding: 5px;'><tr><td colspan='7'>Loading...</td></tr></div>");

        // JW:2021-07-02 - ADO:5014 - This observer must run the serviceability check because the calendar won't be updated
        // with the first date it displays until after this event finishes
        // This fix lets us run serviceability accurately for all 42 days displayed instead of running it for the first of the month
        const elementToObserve = document.querySelector('.datepicker-days table');
        calendarObserver.observe(elementToObserve, {attributes: false, subtree: true, childList: true});
      });
      }
      else {
      $('#selected-date-picker').datepicker({
        language: "en",
        startDate: datePickerReferenceDate,
        minDate: 0,
        autoclose: true,
        maxViewMode: 1,
        disableEntry: true,
        updateViewDate: false,
        orientation: 'bottom',
      }).on('show', function (e) {
        //RS: adding the class for the cloud api if true
        if($('input[name="useCloudAPI"]').val() == "true"){
          $('.datepicker-dropdown').addClass("cloudAPI");
        }
      }).on('changeDate', function (datepicker) {
        document.querySelector('.selectedDate-Input').value = datepicker.date.getTime();
        document.querySelector('.selectedDate-Input').setAttribute('data-date', $(this).val());

        document.getElementById('selected-date-picker').classList.remove('is-invalid');
        const storageLocation = document.querySelector('.storage-location');
        //rs 2023-03-10 - Grab the original session value, if things go wrong, we need the postal code exception
        var currentWarehouseStatus = sessionStorage.getItem('PostalCodeExceptionNSO');
        var selectedDateUTCTimestamp = new Date(Date.UTC(new Date(datepicker.date).getUTCFullYear(), new Date(datepicker.date).getUTCMonth(), new Date(datepicker.date).getUTCDate())).getTime();
        for (var i in generalDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(generalDates[i].Date).getUTCFullYear(), new Date(generalDates[i].Date).getUTCMonth(), new Date(generalDates[i].Date).getUTCDate()));
          if (checkedDateUTCValue.getTime() == selectedDateUTCTimestamp) {
            //rs 2023-03-10 - Check the postal code exception, still respecting that if the sales are blocked in the module, it will always be false
            if(generalDates[i].LocalSalesBlocked || currentWarehouseStatus == 1) {
              storageLocation.setAttribute('data-warehouse-storage-status', 1);
            }
            else if(currentWarehouseStatus == 2 ) {
              storageLocation.setAttribute('data-warehouse-storage-status', 2);
            }
            else if(currentWarehouseStatus == 3 ) {
              storageLocation.setAttribute('data-warehouse-storage-status', 3);
            }
            else {
              storageLocation.setAttribute('data-warehouse-storage-status', 0);
            }
          }
        }
        SetStorageLocationStatus();
        $("#summary").hide();
      }).on('changeMonth', function () {
        if (originZip == null || originZip == "")
          return;

        $(".datepicker-days tbody").hide();
        $("div.datepicker-days table").after("<div id='loadingTBody' style='width: 284px; border: 2px solid #c6cdd4; font-weight: bold; text-align: center; padding: 5px;'><tr><td colspan='7'>Loading...</td></tr></div>");

        // JW:2021-07-02 - ADO:5014 - This observer must run the serviceability check because the calendar won't be updated
        // with the first date it displays until after this event finishes
        // This fix lets us run serviceability accurately for all 42 days displayed instead of running it for the first of the month
        const elementToObserve = document.querySelector('.datepicker-days table');
        calendarObserver.observe(elementToObserve, {attributes: false, subtree: true, childList: true});
      });
      }
  }, false);

  function HandleZipCodeKeyUp(originZip, destinationZip, targetElement, source) {
    referencedMonths = [];
    let serviceabilityChecked = false;
    if (ValidateZip(originZip)) {
      var data = GetServiceabilityParameters();
      if (data.serviceType == 2 || ((data.serviceType == 1 || data.serviceType == 3) && ValidateZip(destinationZip))) {
        serviceabilityChecked = true;
        //Send value to api
        document.getElementById('QuoteFlowWidget').classList.add('loading-widget');
        targetElement.classList.remove('is-invalid');
        $("#summary").hide();
        SendServiceabilityRequest(data, originZip, source);
      }
    }
    else {
      document.getElementById('QuoteFlowWidget').classList.remove('loading-widget');
    }

    if (!serviceabilityChecked) {
      $('.selected-date-picker').prop('disabled', true);
    }
  }

  function ResetSoldOutLabel() {
    /* Clear out the landingPageUrl each time we call serviceability */
    document.getElementById("storagecenter").disabled = false;
    if (storageCenterSoldOutLabel != "" && document.getElementById("storagecenter-label").innerHTML.indexOf(storageCenterSoldOutLabel) !== -1) {
      document.getElementById("storagecenter-label").innerHTML = document.getElementById("storagecenter-label").innerHTML.split(storageCenterSoldOutLabel);
      document.getElementById("storagecenter-label").innerHTML = document.getElementById("storagecenter-label").innerHTML.replace(",", "");
    }
    document.getElementById("storagecenter-label").classList.remove("sold-out");
    document.getElementById("storagecenter-label").title = "";
  }

  function AddSoldOutLabelToStorageCenterSelection() {
    const storageCenterLabel = document.getElementById("storagecenter-label");
    if (storageCenterLabel.classList.contains('sold-out')) {
      return;
    }
    let storageCenterRadio = document.getElementById("storagecenter");
    storageCenterRadio.disabled = true;
    storageCenterLabel.classList.add("sold-out");
    storageCenterLabel.innerHTML = storageCenterLabel.innerHTML + storageCenterSoldOutLabel;
    //JW:2021-05-26 - ADO:4525 - Need to get by ID again once innerHTML has changed
    storageCenterRadio = document.getElementById("storagecenter");
    storageCenterLabel.title = storageCenterSoldOutTooltip;
    storageCenterRadio.checked = false;
    document.getElementById("onsite").checked = true;
  }

  function AddSoldOutLabelToStorageCenterSelection() {
    let storageCenterLabel = document.getElementById("storagecenter-label");
    if (storageCenterLabel.classList.contains('sold-out')) {
      return;
    }
    const storageCenterRadio = document.getElementById("storagecenter");
    storageCenterRadio.disabled = true;
    storageCenterLabel.classList.add("sold-out");
    storageCenterLabel.innerHTML = storageCenterLabel.innerHTML + storageCenterSoldOutLabel;

    //HHD: 2021-07-15 removing bootstrap tooltips for now
    storageCenterLabel = document.getElementById("storagecenter-label");
    storageCenterLabel.title = storageCenterSoldOutTooltip;
    storageCenterRadio.checked = false;
    document.getElementById("onsite").checked = true;
  }

  function ClearZipCodes() {
    $('#originZipCode').val("");
    $('#destinationZipCode').val("");
    $('.selectedDate-Input').attr("disabled", true);
    $('#selected-date-picker').attr("disabled", true);
  }

  function SetStorageLocationStatus() {
    console.debug("[StorageLocationStatus] Running");
    ResetSoldOutLabel();
    const storageLocation = document.querySelector('.storage-location');
    const warehouseStorageStatus = parseInt(storageLocation.getAttribute('data-warehouse-storage-status'));

    if (warehouseStorageStatus === 1) {
      // JW:2021-05-26 - ADO:4525 - WarehouseStorageNotAvailableAtAll = 1
      AddSoldOutLabelToStorageCenterSelection();
    }
    else if (warehouseStorageStatus === 2) {
      // JW:2021-05-26 - ADO:4525 - WarehouseStorageNotAvailableForStorageOnly = 2
      const storageRadio = document.querySelector(".storage-radio");
      if (storageRadio && storageRadio.checked) {
        AddSoldOutLabelToStorageCenterSelection();
      }
    } else if (warehouseStorageStatus === 3) {
      // JW:2021-05-26 - ADO:4525 - WarehouseStorageNotAvailableForMovingAndStorageOnly = 3
      const movingAndStorageRadio = document.querySelector(".moving-storage-radio");
      if (movingAndStorageRadio && movingAndStorageRadio.checked) {
        AddSoldOutLabelToStorageCenterSelection();
      }
    }
  }

  function handleServicabilityResponse(servicabilityResponse, zip, source) {
    var landingPageURLHiddenField = document.getElementById('hdnLandingPageUrl');
    landingPageURLHiddenField.value = "";

    if (servicabilityResponse.Origin.Value != null) {
      try {
        var ocitystring = servicabilityResponse.Origin.Value[0].Value;
        document.querySelector('.originCity-Input').value = ocitystring;
      } catch (e) {
        console.error("[handleServicabilityResponse] Error trying to parse Origin value")
      }
    }
    if (servicabilityResponse.Destination.Value != null) {
      try {
        var dcitystring = servicabilityResponse.Destination.Value[0].Value;
        document.querySelector('.destinationCity-Input').value = dcitystring;
      } catch (e) {}
    }
    //RS 2022-12-07 - Set status type for later use
    sessionStorage.setItem('StatusType', servicabilityResponse.Status);
    /* JW:2021-06-02 - ADO:4706
      WarehouseStorageAvailable reference
      WarehouseStorageAvailable = 0,
      WarehouseStorageNotAvailableAtAll = 1,
      WarehouseStorageNotAvailableForStorageOnly = 2,
      WarehouseStorageNotAvailableForMovingAndStorageOnly = 3 */
    const storageLocation = document.querySelector('.storage-location');
    storageLocation.setAttribute('data-warehouse-storage-status', servicabilityResponse.WarehouseStorageStatus);
    //rs 2023-03-10 - Set the original postal code exception to a session value
    sessionStorage.setItem('PostalCodeExceptionNSO', servicabilityResponse.WarehouseStorageStatus);
    console.debug("[handleServicabilityResponse] servicabilityResponse", servicabilityResponse);
    SetStorageLocationStatus();

    document.getElementById('QuoteFlowWidget').classList.remove('loading-widget');
    document.querySelector('.moveType-Input').value = moveType;
    document.forms.quoteFlowWidgetForm.action = getPriceUrl;
    var submitButton = $('#quoteFlowWidgetForm input[type=submit]');
    var pavedDriveway = document.querySelector('#pavedDriveway');
    if  (window.location.href.indexOf("/fr") > -1){
      servicabilityResponse.RedirectURL = "/fr" + servicabilityResponse.RedirectURL;
    }
    //submitButton.val("Get a Quote");
    var responseURL = servicabilityResponse.RedirectURL;
    /* AV - StatusCode Translation -> Foundation\ERPIntegration\Models\DataTransfer\KnownStatusCodes.cs */
    if ((servicabilityResponse.StatusCode == 201)) {
      /* PostalCodeException */
      landingPageURLHiddenField.value = servicabilityResponse.RedirectURL;
      $('.selected-date-picker').prop('disabled', false);
      //RS 2022-12-07 - if it's showing, hide
      if (!pavedDriveway.classList.contains('d-none')){
        $('#pavedDriveway').addClass('d-none');
        //submitButton.val("Get a Quote");
      }
    }
    else if (servicabilityResponse.StatusCode == 202 || servicabilityResponse.StatusCode == 203 || servicabilityResponse.StatusCode == 204 || servicabilityResponse.StatusCode == 206) {
      document.querySelector('.moveType-Input').value = "IF";
      landingPageURLHiddenField.value = ''; /* Blank out the landingPageUrl - Input value so that the form submits normally. */
      document.forms.quoteFlowWidgetForm.action = servicabilityResponse.RedirectURL;
      if (!pavedDriveway.classList.contains('d-none')){
        $('#pavedDriveway').addClass('d-none');
        sessionStorage.setItem('destination-warehouse', servicabilityResponse.Destination);
        sessionStorage.setItem('origin-warehouse', servicabilityResponse.Origin);
      }
      if (servicabilityResponse.StatusCode == 203) {
        /* IF Price Display */
        document.querySelector('.moveType-Input').value = "IFNP";
      }
      else if (servicabilityResponse.StatusCode == 204) {
        /* IF No Price */
        document.querySelector('.moveType-Input').value = "IFNP";
      }
      else if (servicabilityResponse.StatusCode == 206) {
        /* IF NBF */
        document.querySelector('.moveType-Input').value = "IFNBF";
      }
    }
    /* RS 2022-09-01 ADO 7179 - remove serviceabilityResponse.ServerUsed to avoid conflict with Cloud API */
    else if (servicabilityResponse.StatusCode == 500 || servicabilityResponse.Status == null || servicabilityResponse.StatusCode == null ||
      servicabilityResponse.GeneralAvailabilityDates == null || servicabilityResponse.SevenFootContainerAvailabilityDates == null ||
      servicabilityResponse.TwelveFootContainerAvailabilityDates == null || servicabilityResponse.SixteenFootContainerAvailabilityDates == null ||
      servicabilityResponse.Origin == null || servicabilityResponse.Destination == null) {
      //RS 2022-12-07 - if it's showing, hide
      if (!pavedDriveway.classList.contains('d-none')){
        $('#pavedDriveway').addClass('d-none');
      }
      /* RS 2022-11-21 ADO 7336 - Toggle Paved driveway Question */
      if ((servicabilityResponse.Status == "CityServiceQualifier") || (servicabilityResponse.Status == "IFCityServiceQualifier")) {
        var originZip = document.querySelector('label[for=originZipCode]').innerText;
        $('#quoteFlowWidgetForm #pavedDriveway legend').html($('#quoteFlowWidgetForm #pavedDriveway legend').html().replace("{Zip}","<span id='zip'>"+originZip+"</span>"));
        if (document.querySelector('.destinationZipCode-Input').value) {
          var destinationZip = originZip + " & " + document.querySelector('label[for=destinationZipCode]').innerText;
          $('#zip').text(destinationZip);
        }
        if (servicabilityResponse.Status == "IFCityServiceQualifier"){
          document.querySelector('.moveType-Input').value = "IF";
          document.forms.quoteFlowWidgetForm.action = servicabilityResponse.RedirectURL;
          landingPageURLHiddenField.value = ''; /* Blank out the landingPageUrl - Input value so that the form submits normally. */
          if (servicabilityResponse.IFAfterHoursURL != null) {
            sessionStorage.setItem('IF_FallbackURL', servicabilityResponse.IFAfterHoursURL);
          }
        }

        $('#pavedDriveway').removeClass('d-none');
        var serviceTypeElement = document.querySelector('input[name=serviceType]:checked');
        var serviceType = "";
        if (serviceTypeElement) {
          serviceType = serviceTypeElement.value;
        }
        if(serviceType == "2"){
          $('#divZipCode').addClass('col-12').removeClass('col-6');
          $('#divQuoteCalender').addClass('col-12').removeClass('col-6');
        }
        setCityServiceRedirect();
      }
      //For IF Moves
      if (servicabilityResponse.Status != "IFMove" && servicabilityResponse.Status != "CityService" && servicabilityResponse.Status != "CityServiceQualifier" && servicabilityResponse.Status !="IFCityServiceQualifier") {
        if (servicabilityResponse.ErrorModal.RedirectURL != null) {
          /* REDIRECT TO LANDING PAGE */
          landingPageURLHiddenField.value = servicabilityResponse.ErrorModal.RedirectURL;
          $('.selected-date-picker').prop('disabled', false);
          SetStorageLocationStatus();
        }
        else {
        // Other Serviceability Issues
          var strModalContent = "<div class=\"quote-flow-form__error-modal\"><div class=\"quote-flow-form-error-modal-scroll-area\"><div class=\"quote-flow-form__error-modal__header\">";

            if (servicabilityResponse.Status == "AreaOutage") {
              strModalContent = strModalContent + "<h3 class=\"modal-heading\">" + servicabilityResponse.ErrorModal.Header + "</h3>";
            }
            else if (servicabilityResponse.Status == "BadZip") {
              if(servicabilityResponse.Origin.Value == null || servicabilityResponse.Origin.Value[0].Value == null){
                strModalContent = strModalContent + "<h2 class=\"modal-heading\">" + servicabilityResponse.ErrorModal.Header + "</h2><h3 class=\"modal- subheading\">" + document.querySelector('#originZipCode').value + "</h3>";
              }
              else if(servicabilityResponse.Destination.Value == null || servicabilityResponse.Destination.Value[0].Value == null){
                strModalContent = strModalContent + "<h2 class=\"modal-heading\">" + servicabilityResponse.ErrorModal.Header + "</h2><h3 class=\"modal- subheading\">" + document.querySelector('#destinationZipCode').value + "</h3>";
              }
            }
            else if (servicabilityResponse.Status == "Maintenance") {
              window.location.href = servicabilityResponse.RedirectURL;
              return true;
              //strModalContent = strModalContent + "<h2 class=\"modal-heading\">" + servicabilityResponse.ErrorModal.Header + "</h2>";
            }
            else {
              strModalContent = strModalContent + "<h4 class=\"modal-heading\">" + servicabilityResponse.ErrorModal.Header + "</h4>";

              if(servicabilityResponse.Origin.Value != null && servicabilityResponse.Origin.Value[0].Value != null && JSON.parse(servicabilityResponse.Origin.Value[0].Value).Warehouse != null && JSON.parse(servicabilityResponse.Origin.Value[0].Value).Warehouse.WarehouseID == null){
                strModalContent = strModalContent + "<h3 class=\"modal- subheading\">" + servicabilityResponse.Origin.Value[0].Label + " " + document.querySelector('#originZipCode').value + "</h3>";
              }
              else if(servicabilityResponse.Destination.Value != null && servicabilityResponse.Destination.Value[0].Value != null && JSON.parse(servicabilityResponse.Destination.Value[0].Value).Warehouse != null && JSON.parse(servicabilityResponse.Destination.Value[0].Value).Warehouse.WarehouseID == null){
                strModalContent = strModalContent + "<h3 class=\"modal- subheading\">" + servicabilityResponse.Destination.Value[0].Label + " " + document.querySelector('#destinationZipCode').value + "</h3>";
              }              
            }

          strModalContent = strModalContent + "</div>";
          strModalContent = strModalContent + "<div class=\"quote-flow-form__error-modal__body modal-body\">" + servicabilityResponse.ErrorModal.Body + "</div>";

            if (servicabilityResponse.ErrorModal.ActionLabel && servicabilityResponse.ErrorModal.ActionLabel != "") {
              strModalContent = strModalContent + "<div class=\"quote-flow-form__modal__action-holder\"><a class=\"btn btn-primary modal-action-link\" href=\"" + servicabilityResponse.ErrorModal.ActionUrl + "\">" + servicabilityResponse.ErrorModal.ActionLabel + "</a></div>";
            }
            if (servicabilityResponse.ErrorModal.PhoneNumberText && servicabilityResponse.ErrorModal.PhoneNumberText != "") {
              strModalContent = strModalContent + "<p class=\"modal-or-label\">" + servicabilityResponse.ErrorModal.Or + "</p>";
              strModalContent = strModalContent + "<a class=\"modal-phone-link\" href=\"" + servicabilityResponse.ErrorModal.PhoneNumberValue + "\">" + servicabilityResponse.ErrorModal.PhoneNumberText + "</a>";
            }
            if (servicabilityResponse.ErrorModal.CancelLabel && servicabilityResponse.ErrorModal.CancelLabel != "") {
              strModalContent = strModalContent + "<div class=\"quote-flow-form__modal__cancel-holder modal-cancel\">" + servicabilityResponse.ErrorModal.CancelLabel + "</div>";
            }

          strModalContent = strModalContent + "</div>";
          showModal(strModalContent);
          $('#originZipCode').val("");
          $('#destinationZipCode').val("");
        }
      }
    }
    else {
      $("#quoteFlowWidgetForm input[type='submit']").html("Get a Quote");
      /* RS 2022-11-21 ADO 7336 - Use the right redirect! */
      if ((servicabilityResponse.Status == "CityService" || servicabilityResponse.Status == "CityServiceQualifier") && servicabilityResponse.ErrorModal.RedirectURL != null) {
        landingPageURLHiddenField.value = servicabilityResponse.ErrorModal.RedirectURL;
        $('.selected-date-picker').prop('disabled', false);
        var originZip = document.querySelector('label[for=originZipCode]').innerText;
        $('#quoteFlowWidgetForm #pavedDriveway legend').html($('#quoteFlowWidgetForm #pavedDriveway legend').html().replace("{Zip}", "<span id='zip'>" + originZip + "</span>"));
        if (document.querySelector('.destinationZipCode-Input').value) {
          var destinationZip = originZip + " & " + document.querySelector('label[for=destinationZipCode]').innerText;
          $('#zip').text(destinationZip);
        }
        $('#pavedDriveway').removeClass('d-none');
        var serviceTypeElement = document.querySelector('input[name=serviceType]:checked');
        var serviceType = "";
        if (serviceTypeElement) {
          serviceType = serviceTypeElement.value;
        }
        if(serviceType == "2"){
          $('#divZipCode').addClass('col-12').removeClass('col-6');
          $('#divQuoteCalender').addClass('col-12').removeClass('col-6');
        }
      }
      else if (pavedDriveway.classList.contains('d-none') == false){
          $('#pavedDriveway').addClass('d-none');
        }
      }
    }

  /////////////////////////////////////////////////////////
  // Salesforce
  /////////////////////////////////////////////////////////

  function SendQuoteToSalesforce(quoteFlowData) {
    var xmlhttp = new XMLHttpRequest();
    var endpoint = salesforceResiUrl;
    xmlhttp.open("POST", endpoint);
    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.send(JSON.stringify(quoteFlowData));
  }
}
